import { Heading, Text } from 'components/typography';
import { Box, Flex } from 'components/box';
import { css } from '@emotion/react';
import Button from 'components/button';
import BackIcon from 'shared/assets/icons/back-caret.svg';
import { X as XIcon } from 'react-feather';
import { FontSizeProps } from 'styled-system';

type SectionTitleProps = FontSizeProps & {
  title: string;
  editButtonText?: string;
  editButtonCallback?: () => void;
  backButtonCallback?: () => void;
  closeButtonCallback?: () => void;
  borderColor?: string;
  showBackButtonAlways?: boolean;
  subText?: string;
  pageTitle?: boolean;
};

const SectionTitle = ({
  title,
  editButtonText,
  editButtonCallback,
  backButtonCallback,
  closeButtonCallback,
  borderColor,
  showBackButtonAlways,
  fontSize = [3, 5],
  subText,
  pageTitle,
}: SectionTitleProps) => (
  <>
    <Flex>
      <Flex
        pb="15px"
        mb="-2px"
        css={theme => css`
          border-bottom: 3px solid
            ${borderColor ? theme.colors[borderColor] : theme.colors.blue};
        `}
      >
        {backButtonCallback && (
          <Flex className={!showBackButtonAlways ? 'show-for-mobile-only' : ''}>
            <Button
              variant="flat"
              onClick={backButtonCallback}
              pr={3}
              pl={0}
              py={0}
              m={0}
            >
              <BackIcon height={15} />
            </Button>
          </Flex>
        )}

        <Heading
          as={pageTitle ? 'h1' : 'h2'}
          fontSize={fontSize}
          textAlign="center"
          m="auto"
          css={css`
            white-space: nowrap;
          `}
        >
          {title}
        </Heading>
      </Flex>

      <Flex
        pb="15px"
        justifyContent="flex-end"
        width="100%"
        css={theme => css`
          border-bottom: 1px solid ${theme.colors.lightishGrey};
        `}
      >
        {editButtonText && editButtonCallback && (
          <Box verticalAlign="center" m="auto" mx={0}>
            <Button
              p={0}
              variant="flat"
              onClick={editButtonCallback}
              fontSize={['12px', '1rem', '1.15rem']}
            >
              {editButtonText}
            </Button>
          </Box>
        )}

        {closeButtonCallback && (
          <Box verticalAlign="center" m="auto" mx={0}>
            <Button
              p={0}
              variant="flat"
              fontColor="darkishGrey"
              hoverColor="darkGrey"
              onClick={closeButtonCallback}
              fontSize={['12px', '1rem', '1.15rem']}
            >
              <XIcon />
            </Button>
          </Box>
        )}
      </Flex>
    </Flex>

    {subText && (
      <Text pt={[3]} pb={[2, 5]}>
        {subText}
      </Text>
    )}
  </>
);

export default SectionTitle;
